export default "__VITE_ASSET__CobX218y__"